/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: 9c5a7c5f (Mon Apr 13 19:32:58 UTC 2026)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { FeeType } from './'

/**
 *
 * @export
 * @interface FeeStructure
 */
export interface FeeStructure {
  /**
   *
   * @type FeeType
   * @memberof FeeStructure
   */
  feeType: FeeType
  /**
   * The minimum cost the fee can be set on a program for this fee type in the specified community's region.
   * @type string
   * @memberof FeeStructure
   */
  minimumAmount: string
  /**
   * The default cost, defined by the specified community's region, that this fee type will be set to if not overwritten on the program.
   * @type string
   * @memberof FeeStructure
   */
  defaultTotalAmount: string
  /**
   * Whether the fee can be set to anything other than the defaultTotalAmount. If false, this fee type will always use the defaultTotalAmount.
   * @type boolean
   * @memberof FeeStructure
   */
  allowEditTotal: boolean
}

export function FeeStructureFromJSON(json: any): FeeStructure {
  return FeeStructureFromJSONTyped(json, false)
}

export function FeeStructureFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): FeeStructure {
  if (json === undefined || json === null) {
    return json
  }
  return {
    feeType: json['feeType'],
    minimumAmount: json['minimumAmount'],
    defaultTotalAmount: json['defaultTotalAmount'],
    allowEditTotal: json['allowEditTotal'],
  }
}

export function FeeStructureToJSON(value?: FeeStructure | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    feeType: value.feeType,
    minimumAmount: value.minimumAmount,
    defaultTotalAmount: value.defaultTotalAmount,
    allowEditTotal: value.allowEditTotal,
  }
}
